<template>
  <div>
    <vue-tags-input
      v-model="tag"
      :tags="tags"
      @tags-changed="newTags"
    />
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  props: ["name", "validation", "content", "dropdown_name", "search"],
  data() {
    return {
      post: [],
      extra: {},
      list: {},
      tag: '',
      tags: [],
    };
  },
  components: {
    VueTagsInput,
  },
  mounted() {
    if (this.dropdown_name == "srv_id") {
      this.dd_label = "srv_name";
      this.dd_value = "srv_id";
      this.post = this.content;
      this.list = this.content;
      this.extra["data"] = this.content;
    }
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
    totalPrice() {
      return 0;
    },
  },
  methods: {
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post,
      });
    },
    searchAutocomplete(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.searchDeb(loading, search, this);
      }
    },
    searchDeb: _.debounce((loading, search, vm) => {
      var params = {};

      if (vm.dropdown_name == "blog_tags_id") {
        vm.dd_label = "blog_t_name";
        vm.dd_value = "blog_t_id";

        params = {
          ["search[blog_t_name]"]: search,
        };
      }

      vm.axios
        .get("/dropdown/autocomplete/" + vm.dropdown_name, { params: params })
        .then((response) => {
          loading(false);
          vm.extra = response.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 350),
    newTags(evt){
      this.tags = evt
      var res = []
      evt.forEach(element => {
        res.push(element.text)
      });
      this.post = res;

      this.$emit("post", {
        name: this.name,
        value: this.post,
      });        
    }
  },
};
</script>